import React from 'react';
import Image from '../../elements/image/image';

import { CarouselSlider, CarouselSliderElement } from './phone-carousel-styles';
import { PhoneCarouselPhoneIndex } from './PhoneCarousel.landing';

interface PhoneCarouselHorizontalViewProps {
  indexedPhonesItems: PhoneCarouselPhoneIndex[];
  carouselRotationIndex: number;
}

const PhoneCarouselHorizontalView = ({ indexedPhonesItems, carouselRotationIndex }: PhoneCarouselHorizontalViewProps): JSX.Element => {
  return (
    // 248px is the images standard width by design
    <CarouselSlider style={{ transform: `translateX(calc(248px * -${carouselRotationIndex}))` }}>
      {
        indexedPhonesItems.map((phoneItem, index) => {
          return (
            <CarouselSliderElement key={index} >
              <Image childImageSharp={phoneItem.image.gatsbyImageData} alt={`phone-image-${phoneItem.phoneIndex + 1}`} />
            </CarouselSliderElement>
          )
        })
      }
    </CarouselSlider>
  )
}

export default PhoneCarouselHorizontalView;
